<footer>
    <section class="info">
        <div class="copyright"
             i18n="@@footer.copyright">© {{currentYear}} Webmozarts GmbH</div>
        <div class="version">
            <ng-container i18n="@@footer.version">Version</ng-container>:
            {{ version }}
        </div>
    </section>

    <section class="webmozarts">
        <a href="https://webmozarts.com" target="_blank" rel="noopener">
            <ng-container i18n="@@footer.developedBy">Entwickelt von</ng-container>
            <img class="logo" src="assets/img/webmozarts-logo.png" alt="Webmozarts Logo"/>
            <img class="text" src="assets/img/webmozarts-text.svg" alt="Webmozarts"/>
        </a>
    </section>

    <section class="links">
        <nav>
            @for (navItem of navItems; track navItem.url) {
                @if (navItem.external) {
                    <a [href]="navItem.url"
                       target="_blank"
                       rel="noopener">
                        {{navItem.label}}
                    </a>
                } @else {
                    <a [routerLink]="navItem.url">
                        {{navItem.label}}
                    </a>
                }
            }
        </nav>
    </section>
</footer>
